module.exports = __webpack_public_path__ + "img/warning.3be88463.svg";